import React from 'react';
import { Container, Row, Form, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { Trader } from './trader';
import { Button } from 'react-bootstrap';
import { CellPhoneRegex, PhoneRegex } from 'common/validation';

export type AddTraderDetailsProps = {
	trader: Trader;
	showEditMode: boolean;
	handleNext: any;
	validated: boolean;
	handleCancel: any;
	showDeleteModal: any;
	onTraderUpdated(trader: Trader): void;
};

const AddTraderDetails = (props: AddTraderDetailsProps) => (
	<Container>
		<Form noValidate validated={props.validated} onSubmit={props.handleNext}>
			<Form.Group as={Row}>
				<Form.Label className="required">First Name</Form.Label>
				<Form.Control
					type="text"
					name="firstName"
					defaultValue={props.trader.firstName}
					onChange={(event: any) => props.onTraderUpdated({...props.trader, firstName: event.target.value?.trim()})}
					required
				/>
				<Form.Control.Feedback type="invalid">Please provide a valid first name.</Form.Control.Feedback>
			</Form.Group>
			<Form.Group as={Row}>
				<Form.Label className="required">Last Name</Form.Label>
				<Form.Control
					type="text"
					name="lastname"
					defaultValue={props.trader.lastName}
					onChange={(event: any) => props.onTraderUpdated({...props.trader, lastName: event.target.value?.trim()})}
					required
				/>
				<Form.Control.Feedback type="invalid">Please provide a valid last name.</Form.Control.Feedback>
			</Form.Group>
			<Form.Group as={Row}>
				<Form.Label className="optional">ERP ID (optional)</Form.Label>
				<Form.Control
					type="text"
					name="erpId"
					defaultValue={props.trader.erpId}
					onChange={(event: any) => props.onTraderUpdated({...props.trader, erpId: event.target.value?.trim()})}
				/>
			</Form.Group>
			<Form.Group as={Row}>
				<Form.Label className="required">Email</Form.Label>
				<Form.Control
					type="email"
					name="email"
					defaultValue={props.trader.email}
					onChange={(event: any) => props.onTraderUpdated({...props.trader, email: event.target.value?.trim()})}
					required
					disabled={props.showEditMode}
				/>
				<Form.Control.Feedback type="invalid">Please provide a valid email.</Form.Control.Feedback>
			</Form.Group>
			<Form.Group as={Row}>
				<Form.Label className="required">Phone Number</Form.Label>
				<Form.Control
					type="text"
					name="phone"
					pattern={PhoneRegex.source}
					defaultValue={props.trader.phone}
					onChange={(event: any) => props.onTraderUpdated({...props.trader, phone: event.target.value?.trim()})}
					required
				/>
				<Form.Control.Feedback type="invalid">Please provide a valid phone number.</Form.Control.Feedback>
			</Form.Group>
			<Form.Group as={Row}>
				<Form.Label className="optional">Cell Phone (to receive text alerts)</Form.Label>
				<Form.Control
					type="text"
					name="cellPhone"
					pattern={CellPhoneRegex.source}
					defaultValue={props.trader.cellPhone}
					onChange={(event: any) => props.onTraderUpdated({ ...props.trader, cellPhone: event.target.value.trim() === "" ? null : event.target.value.trim()})}
				/>
			</Form.Group>
			{props.showEditMode &&
			<Form.Group as={Row}>
				<Form.Label>Trader ID (Tag 116)</Form.Label>
				<Form.Control
					type="text"
					name="castId"
					readOnly
					defaultValue={props.trader.castId}
				/>
			</Form.Group>
			}

			<div className="row">
				<div className="col-4">
					{props.showEditMode && (
						props.trader.canManageTraders ? 
						<OverlayTrigger
						 overlay={<Tooltip id="tooltip-delete-trader">Please contact your Broker to delete this trader.</Tooltip>}>
							<div className="pull-left mt-5">
								<span style={{ fontSize: 'x-large', color: "gray" }}  className="fa fa-trash"/>
							</div>
						</OverlayTrigger> :
						<button className="btn btn-link pull-left mt-5" onClick={props.showDeleteModal}>
							<span style={{ fontSize: 'x-large' }}  className="fa fa-trash" />
						</button>
					)}
					
				</div>
				<div className="col-8">
					<div className="pull-right mt-5">
						<Button variant="secondary" onClick={props.handleCancel}>
							Cancel
						</Button>
						<Button variant="primary" className="ml-2" type="submit">
							Next
						</Button>
					</div>
				</div>
			</div>
		</Form>
	</Container>
);

export default AddTraderDetails;
